import { auth } from '../auth/auth';
import { geo } from '../geo/geo';

export const api = {


  async apiQuery(method, handler, params) {
    console.log('Making API query');
    const token = await auth.getToken();
    if (!token) {
      console.log('No token found');
      //return null;
    }
    
    try {
      let url = `https://zjx6kmaei3.execute-api.us-east-1.amazonaws.com/default${handler}`;
      let options = {
        method: method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      };

      // Add current location to params if needed
      if (params) {
        const location = geo.getCurrentPosition();
        if (location.latitude && location.longitude) {
          params.location = location;
        }
      }

      if (method === 'GET' && params && Object.keys(params).length > 0) {
        // Serialize nested objects properly
        const searchParams = new URLSearchParams();
        Object.keys(params).forEach(key => {
          const value = params[key];
          if (typeof value === 'object' && value !== null) {
            searchParams.append(key, JSON.stringify(value));
          } else {
            searchParams.append(key, value);
          }
        });
        url += '?' + searchParams.toString();
      } else if (method === 'POST' && params) {
        options.body = JSON.stringify(params);
      }

      const response = await fetch(url, options);

      let data = await response.json();

      // Check if response is Unauthorized
      if (data?.message === 'Unauthorized') {
        console.log('Received Unauthorized, attempting token refresh');
        
        // Attempt to refresh the token
        const newToken = await auth.refreshAccessToken();
        
        if (newToken) {
          // Retry the original request with the new token
          console.log('Token refreshed, retrying original request');
          options.headers['Authorization'] = `Bearer ${newToken}`;
          
          const retryResponse = await fetch(url, options);

          data = await retryResponse.json();

          if (!retryResponse.ok) {
            // Return the parsed error body so callers can inspect specific error codes/messages
            return data;
          }
        } else {
          // Refresh failed, user needs to login again
          throw new Error('Session expired. Please log in again.');
        }
      }

      // If response not ok, return parsed body so callers can inspect error info
      if (!response.ok) {
        return data;
      }
      return data;
    } catch (error) {
      console.error('Error making API query:', error);
      return null;
    }
  }

}
